import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  goToIntegrationGuide: new analytics.Event({
    name: 'Integration Guide Clicked',
    description: 'Go to the integration guide for selected platform',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.LEAVE_FLOW,
    type: analytics.EVENT_TYPE.NAVIGATION,
    properties: ['platform'],
    userAttributes: ['platform'],
  }),
};
